import DiscoverAllocatorMeetingRequest from './DiscoverAllocatorMeetingRequest'

export default DiscoverAllocatorMeetingRequest
